import React, { useState } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Imágenes de la galería (sin repetir las del hero/superior: Comunidad, Colombia, Bienestar)
  const galleryItems = [
    {
      id: 1,
      title: 'Colección Javiland',
      tag: 'TIENDA',
      image: '/images/tienda-carousel-coleccion-javiland.png',
      description: 'Camiseta exclusiva. Hecho en Colombia.',
      link: '/tienda',
      cta: 'Ver colección'
    },
    {
      id: 2,
      title: 'Café Kaaba',
      tag: 'PRODUCTOS NATURALES',
      image: '/images/tienda-carousel-cafe-kaaba.png',
      description: 'Café de origen. Desde Colombia para el mundo.',
      link: '/tienda?category=productos-naturales',
      cta: 'Explorar'
    },
    {
      id: 3,
      title: 'Yoga & Meditación',
      tag: 'BIENESTAR',
      image: '/images/bienestar-carousel-yoga-meditacion.png',
      description: 'Sesiones personalizadas para tu bienestar.',
      link: '/bienestar',
      cta: 'Ver calendario'
    },
    {
      id: 4,
      title: 'Talleres de Crecimiento',
      tag: 'EXPERIENCIAS',
      image: '/images/bienestar-carousel-talleres-crecimiento.png',
      description: 'Alimentación consciente y desarrollo personal.',
      link: '/bienestar',
      cta: 'Explorar talleres'
    },
    {
      id: 5,
      title: 'Conecta con tu Esencia',
      tag: 'COMUNIDAD',
      image: '/images/bienestar-carousel-conecta-esencia.png',
      description: 'Únete a nuestra comunidad de transformación.',
      link: '/bienestar',
      cta: 'Unirse ahora'
    },
    {
      id: 6,
      title: 'Conoce Colombia',
      tag: 'VIAJES',
      image: '/images/hero-viajes-colombia.png',
      description: 'Pacífico, San Andrés, Amazonas y Tayrona.',
      link: '/conoce-colombia',
      cta: 'Ver experiencias'
    }
  ];

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const handleItemClick = (item) => {
    setSelectedImage(item);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <section className="gallery gallery-banner" id="galeria">
      <div className="gallery-layout">
        {/* Columna título */}
        <div className="gallery-side">
          <h2 className="gallery-headline">Desde Colombia al mundo</h2>
          <button
            className="gallery-cta-main"
            onClick={() => navigateToPage('/tienda')}
          >
            Ver toda la tienda
          </button>
        </div>

        {/* Grid de imágenes - diseño mejorado */}
        <div className="gallery-grid gallery-grid-ia">
          {galleryItems.map(item => (
            <div
              key={item.id}
              className="gallery-card"
              onClick={() => handleItemClick(item)}
            >
              <div className="gallery-card-image">
                <img
                  src={item.image}
                  alt={item.title}
                  onError={(e) => {
                    e.target.src = '/images/placeholders/placeholder.svg';
                  }}
                />
                <div className="gallery-card-overlay">
                  <span className="gallery-card-tag">{item.tag}</span>
                  <h3 className="gallery-card-title">{item.title}</h3>
                  <p className="gallery-card-desc">{item.description}</p>
                  <button
                    className="gallery-card-cta"
                    onClick={(e) => { e.stopPropagation(); navigateToPage(item.link); }}
                  >
                    {item.cta}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <i className="fas fa-times"></i>
            </button>
            <div className="lightbox-image">
              <img src={selectedImage.image} alt={selectedImage.title} />
            </div>
            <div className="lightbox-info">
              <span className="lightbox-tag">{selectedImage.tag}</span>
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.description}</p>
              <button
                className="lightbox-cta-btn"
                onClick={() => { closeLightbox(); navigateToPage(selectedImage.link); }}
              >
                <i className="fas fa-arrow-right"></i>
                {selectedImage.cta}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
